namespace TabAurous.Sales {
    export namespace ApprovalOutReturnBOMService {
        export const baseUrl = 'Sales/ApprovalOutReturnBOM';

        export declare function Create(request: Serenity.SaveRequest<ApprovalOutReturnBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ApprovalOutReturnBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ApprovalOutReturnBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalOutReturnBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Sales/ApprovalOutReturnBOM/Create",
            Update = "Sales/ApprovalOutReturnBOM/Update",
            Delete = "Sales/ApprovalOutReturnBOM/Delete",
            Retrieve = "Sales/ApprovalOutReturnBOM/Retrieve",
            List = "Sales/ApprovalOutReturnBOM/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ApprovalOutReturnBOMService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
